<template>
  <div>
    <MyBanner
      :text="$t('banner.accessDcPage')"
      v-if="$t('banner.accessDcPage') != ''"
    />
    <MyHeaderPage
      :title="$t('reports.virtualization.title')"
      :subtitle="$t('reports.virtualization.subTitle')"
    />
    <br /><br />
    <div id="TicketsList">
      <div class="listTicket">
        <!-- FILTRO -->
        <div class="mdl-grid">
          <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone">
            <div class="filterTickets">
              <div class="contentInputFilter">
                <div class="contentIcon">
                  <span class="material-icons">search</span>
                </div>
                <div class="contentInput">
                  <input
                    type="text"
                    :placeholder="$t('actions.text_search_placeholder')"
                    v-model="searchString"
                    @keyup="searchByString"
                  />
                </div>
              </div>
            </div>
          </div>
          <!--  CSV Export Button -->
          <div
            class="mdl-cell mdl-cell--2-col mdl-cell--7-offset mdl-cell--12-col-phone"
          >
            <ActionButton
                  custom-class="cdlButton"
                  :loading="isExporting"
                  :disabled="!viewLoader"
                  @click="exportCsv"
                >
              <img src="@/assets/img/download.png" alt="icon" />
              {{ $t("users.downLoadCSV") }}
            </ActionButton>
          </div>
        </div>
        <!-- FINE FILTRO -->
        <div class="mdl-grid">
          <div class="mdl-cell mdl-cell--12-col">
            <br />
            <table>
              <thead v-if="!this.$IsMobile()">
                <tr>
                  <th>{{ $t("reports.virtualization.col.colOne") }}</th>
                  <th>{{ $t("reports.virtualization.col.colTwo") }}</th>
                  <th v-if="!this.$IsMobile()">
                    {{ $t("reports.virtualization.col.colThree") }}
                  </th>
                  <th v-if="!this.$IsMobile()">
                    {{ $t("reports.virtualization.col.colFour") }}
                  </th>
                  <th v-if="!this.$IsMobile()">
                    {{ $t("reports.virtualization.col.colFive") }}
                  </th>
                  <th v-if="!this.$IsMobile()">
                    {{ $t("reports.virtualization.col.colSix") }}
                  </th>
                </tr>
              </thead>
              <tbody
                v-if="
                  !this.$IsMobile() && this.viewLoader && pagedItems.length > 0
                "
              >
                <tr
                  v-for="(item, keyItem) in this.pagedItems"
                  :key="keyItem"
                  :class="{ odd: keyItem % 2 }"
                >
                  <td>{{ item.name }}</td>
                  <td>{{ item.volumetotal }}</td>
                  <td>{{ item.cputotal }}</td>
                  <td>{{ item.memorytotal }}</td>
                  <td>{{ item.primarystoragetotal }}</td>
                  <td>{{ item.secondarystoragetotal }}</td>
                </tr>
              </tbody>
              <tbody
                v-else-if="
                  this.$IsMobile() && this.viewLoader && pagedItems.length > 0
                "
              >
                <MobileCard
                  v-for="(item, keyItem) in this.pagedItems"
                  :key="keyItem"
                  :titles="['name', 'volumetotal']"
                  :item="item"
                  translation-path="reports.virtualization.list"
                ></MobileCard>
              </tbody>
              <tbody
                v-if="
                  itemFilter.length === 0 &&
                  viewLoader &&
                  pagedItems.length === 0
                "
              >
                <tr>
                  <td colspan="6">
                    <span class="noTickets">{{ $t("reports.noResult") }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <div>
              <MyLoading :viewLoader="this.viewLoader" type="" />
            </div>
            <Paginator
              v-if="viewLoader && totalItems > 0"
              :total-page="paginatedItems"
              :current-page="currentPage"
              :itemsPerPage="itemsPerPage"
              @prev-page="beforePage"
              @next-page="nextPage"
              @change-page="changePage"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyBanner from "@/components/MyBanner.vue";
import MyHeaderPage from "@/components/MyHeaderPage.vue";
import MyLoading from "@/components/MyLoading.vue";
import "@/assets/scss/TicketsList.scss";
import MobileCard from "@/components/Cards/MobileCard.vue";
import Paginator from "@/components/Paginator.vue";
import { exportCsvReport } from '@/services/CSVExportService.js'
import DownloadBinaryFile from '@/services/FileService'
import ActionButton from '@/components/Primitives/Buttons/ActionButton.vue'

export default {
  name: "CVirtualization",
  components: {
    MobileCard,
    MyBanner,
    MyHeaderPage,
    MyLoading,
    Paginator,
    ActionButton
  },
  data() {
    return {
      viewLoader: false,
      items: [],
      itemFilter: [],
      // Add these for pagination
      currentPage: 1,
      itemsPerPage: 10,
      paginatedItems: 0,
      totalItems: 0,
      // For the CSV export
      isExporting: false,
      searchString: "",
    };
  },
  methods: {
    searchByString() {
      // Reset pagination when searching
      this.currentPage = 1;

      // If server-side search is implemented
      if (this.searchString.length >= 3 || this.searchString.length === 0) {
        this.getList();
      } else {
        // Client-side filtering as fallback
        this.itemFilter = [];
        let elm = this.searchString.toLowerCase();
        this.items.forEach((item) => {
          let name = item.name ? item.name.toLowerCase().includes(elm) : false;
          let volumetotal = item.volumetotal
            ? item.volumetotal.toString().toLowerCase().includes(elm)
            : false;
          let cputotal = item.cputotal
            ? item.cputotal.toString().toLowerCase().includes(elm)
            : false;
          let memorytotal = item.memorytotal
            ? item.memorytotal.toString().toLowerCase().includes(elm)
            : false;
          let primarystoragetotal = item.primarystoragetotal
            ? item.primarystoragetotal.toString().toLowerCase().includes(elm)
            : false;
          let secondarystoragetotal = item.secondarystoragetotal
            ? item.secondarystoragetotal.toString().toLowerCase().includes(elm)
            : false;

          if (
            name ||
            volumetotal ||
            cputotal ||
            memorytotal ||
            primarystoragetotal ||
            secondarystoragetotal
          ) {
            this.itemFilter.push(item);
          }
        });
      }
    },
    getList() {
      this.viewLoader = false;
      let he = {
        Accept: "application/json",
        Authorization: "Bearer " + this.$keycloak.idToken,
      };
      const self = this;

      let par = "";
      if (this.itemsPerPage) {
        par += "?per_page=" + this.itemsPerPage;
      } else {
        par += "?";
      }

      // Add page parameter
      if (par.includes("?")) {
        par += "&page=" + this.currentPage;
      } else {
        par += "?page=" + this.currentPage;
      }

      // Add search parameter if exists
      if (this.searchString && this.searchString.trim() !== "") {
        par += "&search=" + this.searchString;
      }

      this.axios
        .get(
          window.VUE_APP_MISTRA_URL +
            "front/v1/report-virtualization" +
            par,
          { headers: he }
        )
        .then((response) => {
          // Handle the pagination structure
          if (response.data.data) {
            // If the API returns paginated data
            this.items = response.data.data;
            this.currentPage = response.data.current_page || 1;
            this.itemsPerPage = response.data.per_page || 10;
            this.totalItems = response.data.total || this.items.length;
            this.paginatedItems = Math.ceil(
              this.totalItems / this.itemsPerPage
            );
          } else {
            // If the API returns a simple array
            this.items = response.data;
            this.totalItems = this.items.length;
            this.paginatedItems = 1;
          }

          this.itemFilter = this.items;
          this.viewLoader = true;
        })
        .catch(function (err) {
          self.viewLoader = true;
          console.log(err);
        });
    },

    // Methods to handle pagination for the Paginator component
    changePage(page) {
      this.currentPage = page;
      this.getList();
    },

    beforePage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getList();
      }
    },

    nextPage() {
      if (this.currentPage < Math.ceil(this.totalItems / this.itemsPerPage)) {
        this.currentPage++;
        this.getList();
      }
    },

    // Add this method for CSV 
     async exportCsv() {
      this.isExporting = true;
      const params = {
        from: this.dateFrom,
        to: this.dateTo,
        csv: true,
        ...(this.searchString?.trim() && { search: this.searchString })
      };

      try {
        const { blob, headers } = await exportCsvReport(
          window.VUE_APP_MISTRA_URL + "front/v1/report-virtualization/",
          this.$keycloak.idToken,
          params
        );
        const match = headers["content-disposition"]?.match(/filename="(.+)"/);
        const filename = match?.[1] ?? "virtualization_report.csv";
        DownloadBinaryFile.downloadBlob(blob, filename);
      } catch (error) {
        console.error(error);
      } finally {
        this.isExporting = false;
      }
    },

    /*exportCsv() {
      this.isExporting = true;

      // Create URL with all current filter parameters
      let par = "";
      if (this.searchString && this.searchString.trim() !== "") {
        par += "&search=" + this.searchString;
      }

      let header = {
        Authorization: "Bearer " + this.$keycloak.idToken,
        Accept: "text/csv",
      };

      this.axios
        .get(
          window.VUE_APP_MISTRA_URL +
            "front/v1/report-virtualization?csv=true" +
            par,
          { headers: header }
        )
        .then((response) => {
          // Create a blob URL and trigger download
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;

          // Get filename from headers or use default
          const contentDisposition = response.headers["content-disposition"];
          let filename = "virtualization_report.csv";

          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename="(.+)"/);
            if (filenameMatch && filenameMatch.length === 2) {
              filename = filenameMatch[1];
            }
          }

          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.isExporting = false;
        })
        .catch((error) => {
          console.error("Error downloading CSV:", error);
          this.isExporting = false;
        });
    },*/
  },
  mounted() {
    this.getList();
  },
  computed: {
    pagedItems() {
      return this.items || [];
    },
    totalPages() {
      return Math.ceil(this.itemFilter.length / this.itemsPerPage);
    },
  },
};
</script>
